export default "__VITE_ASSET__BJ7EP260__"